import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Bem-vindo à Área Administrativa</h1>
      <p>Você está logado como administrador.</p>
      
      <button
        onClick={handleLogout}
        style={{
          marginTop: '1.5rem',
          padding: '0.75rem 1.25rem',
          backgroundColor: '#e74c3c',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Sair da Conta
      </button>
    </div>
  );
};

export default Dashboard;
